module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1034-fcb2fc159fd36ce34001d990e87cafae.png";